import React from "react";
import "./Scroll.css";

const Scroll = () => {
  return (
    <nav className="scroll">
      <ul className="scroll-list">
        <li className="scroll-item">
          <a href="https://wa.me/34603141447" target="_blank" rel="noreferrer">
            <i
              style={{
                color: "#24cc63",
              }}
              className="fab fa-whatsapp fa-2x"
            ></i>
          </a>
        </li>
        <li className="scroll-item">
          <a
            href="https://www.instagram.com/luka_rostom"
            target="_blank"
            rel="noreferrer"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "35px",
              width: "35px",
              textAlign: "center",
              color: "#fff",
              verticalAlign: "middle",
              background: "#d6249f",
              background:
                "radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%)",
              boxShadow: "0px 3px 10px rgba(0,0,0,.25)",
              borderRadius: "5px",
            }}
          >
            <i className="fab fa-instagram fa-2x"></i>
          </a>
        </li>
        <li className="scroll-item">
          <a
            href="https://www.facebook.com/luka.cackrialashvili/"
            target="_blank"
            rel="noreferrer"
          >
            <i
              style={{
                color: "#0675e8",
              }}
              className="fab fa-facebook fa-2x"
            ></i>
          </a>
        </li>
        <li className="scroll-item">
          <a
            href="https://www.youtube.com/@lukarostomashvili"
            target="_blank"
            rel="noreferrer"
          >
            <i
              style={{
                color: "red",
              }}
              className="fab fa-youtube fa-2x"
            ></i>
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Scroll;
